import {
  FormControl,
  Typography,
  FormControlLabel,
  FormGroup,
  Checkbox,
} from "@mui/material";
import { Controller } from "react-hook-form";
import { useSelector } from "react-redux";
import { getBasketTotals, getEatIn } from "../../../redux/basketSlice";
import { selectStoreHasInPrice } from "../../../redux/storeDataSlice";
import { FORMATTER } from "../../../services";
import { useTranslation } from "react-i18next";

const CheckoutStep5 = ({ step, control, availableForUse }) => {
  const { t } = useTranslation();
  const hasInPrice = useSelector(selectStoreHasInPrice);
  const eatInRaw = useSelector(getEatIn);
  const eatIn = hasInPrice ? eatInRaw : false;
  const totals = useSelector(getBasketTotals);
  const { sumTotal } = totals[eatIn ? "priceIn" : "priceOut"];
  const restToPay = sumTotal - availableForUse;

  if (availableForUse > 0) {
    return (
      <>
        <Typography variant="h5" component="h2" sx={{ padding: "15px" }}>
          {step}. {t("Bruk bonus?")}
        </Typography>
        <Typography variant="p" component="div" sx={{ padding: "15px" }}>
          <p>
            {t(
              "Du kan bruke av din bonus for å redusere prisen på bestillingen."
            )}
          </p>
          <p
            dangerouslySetInnerHTML={{
              __html: t(
                "På denne bestillingen kan du redusere prisen med <b>kr. {{amount}}</b> ved bruk av bonus.",
                {
                  amount: FORMATTER.formatCurrent(availableForUse),
                  interpolation: { escapeValue: false },
                }
              ),
            }}
          ></p>
          <p
            dangerouslySetInnerHTML={{
              __html: t("Det gjenstår da <b>kr. {{amount}}</b> å betale.", {
                amount: FORMATTER.formatCurrent(restToPay),
                interpolation: { escapeValue: false },
              }),
            }}
          ></p>
        </Typography>
        <Controller
          name="useBonus"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox checked={value} onChange={onChange} />}
                  label={t(`Jeg ønsker å bruke kr. {{amount}} bonus nå`, {
                    amount: FORMATTER.formatCurrent(availableForUse),
                  })}
                />
              </FormGroup>
            </FormControl>
          )}
        />
      </>
    );
  } else {
    return (
      <>
        <Typography variant="h5" component="h2" sx={{ padding: "15px" }}>
          {step}. {t("Bruk bonus?")}
        </Typography>
        <Typography variant="p" component="div" sx={{ padding: "15px" }}>
          <p>
            {t(
              "Du kan dessverre ikke bruke av din bonus for å redusere prisen på denne bestillingen."
            )}
          </p>
        </Typography>
      </>
    );
  }
};

export default CheckoutStep5;
